<template>
  <v-navigation-drawer v-model="drawer" :mini-variant="isCollapsed" :mini-variant-width="60" width="350" right app
    permanent :right="$vuetify.rtl" class="side-menu">
    <!-- Header Section -->
    <div class="menu-header">
      <div class="header-actions">
        <div v-if="!isCollapsed" class="logout-action">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="logOut()" class="action-button logout-button">
                <img src="@/assets/sideNav/icon_logout.svg" alt="התנתק">
              </v-btn>
            </template>
            <span>התנתק</span>
          </v-tooltip>
        </div>

        <div v-if="isAdminSwitched" class="switch-action">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="swichToAdmin()" class="action-button switch-button">
                <v-icon medium color="#ffb91a">mdi-swap-horizontal</v-icon>
              </v-btn>
            </template>
            <span>חזור לניהול</span>
          </v-tooltip>
        </div>

        <div v-if="isAgentSwitched" class="switch-action">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="swichToAgent()" class="action-button switch-button">
                <v-icon medium color="#ffb91a">mdi-swap-horizontal</v-icon>
              </v-btn>
            </template>
            <span>חזור לניהול סוכן</span>
          </v-tooltip>
        </div>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="toggleDrawer()" class="action-button toggle-button">
              <v-icon color="#ffb91a">{{ isCollapsed ? 'mdi-chevron-left' : 'mdi-chevron-right' }}</v-icon>
            </v-btn>
          </template>
          <span>{{ isCollapsed ? 'הרחב תפריט' : 'כווץ תפריט' }}</span>
        </v-tooltip>
      </div>

      <!-- Logo Section -->
      <div v-if="!isCollapsed" class="logo-section">
        <div class="main-logo">
          <img src="https://cpanel.clickcall.co.il/serverscall/sys_icon/logo.png" alt="Logo">
        </div>
        <div class="secondary-logo">
          <img src="@/assets/sideNav/second_menu_logo.svg" alt="Secondary Logo">
          <div class="logo-text">
            <span>מערכת ניהול</span>
            <span class="highlight-text">מה נשמע פון</span>
          </div>
        </div>
        <div class="menu-divider"></div>
      </div>
    </div>

    <!-- Menu Items - Expanded View -->
    <transition name="fade-slide">
      <div v-if="!isCollapsed" class="menu-items-container">
        <v-list nav class="menu-list">
          <v-list-item v-for="(item, index) in visibleMenuItems" :key="index" @click="onItemClick(item)"
            class="menu-list-item" :class="{ 'active': isItemActive(item) }">
            <v-list-item-icon class="menu-icon">
              <img :src="item.icon" :alt="item.label" class="menu-icon-img">
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="menu-item-title">{{ item.label }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </transition>

    <!-- Menu Items - Collapsed View -->
    <transition name="fade-slide">
      <div v-if="isCollapsed" class="collapsed-menu-container">
        <v-list nav dense class="collapsed-menu-list">
          <v-list-item v-for="(item, index) in visibleMenuItems" :key="index" @click="onItemClick(item)"
            class="collapsed-menu-item" :class="{ 'active': isItemActive(item) }">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-list-item-icon v-on="on" class="collapsed-icon">
                  <img :src="item.icon" :alt="item.label" class="mini-icon">
                </v-list-item-icon>
              </template>
              <span>{{ item.label }}</span>
            </v-tooltip>
          </v-list-item>
        </v-list>
      </div>
    </transition>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-navigation-drawer>
</template>

<script>
import SnackBar from '@/components/widgets/snackBar.vue'
import Auth from '@/services/auth.service.js'
import { mapState, mapMutations } from 'vuex';
import { isSurveysAllowed } from '@/services/systemSettings.service'

export default {
  components: {
    SnackBar
  },
  data: () => ({
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    search: "",
    isCollapsed: false,
    drawer: true,
    // שלוחת הסקרים כלולה במערכת (exten_permissions.surveys). בלי זה הפריט מוסתר
    surveysAllowed: false,
    menuItems: [
      {
        icon: 'https://cpanel.clickcall.co.il/serverscall/admin/assets/images/v3/system/icon_1.png',
        label: 'דף הבית',
        route: 'home',
        routeName: 'home'
      },
      {
        icon: require('@/assets/sideNav/icon_account.svg'),
        label: 'אזור אישי',
        route: 'account',
        routeName: 'account'
      },
      {
        icon: 'https://cpanel.clickcall.co.il/serverscall/admin/assets/images/v3/system/icon_4.png',
        label: 'שיחות און ליין',
        route: 'onLineUsers',
        routeName: 'onLineUsers'
      },
      {
        icon: 'https://cpanel.clickcall.co.il/serverscall/admin/assets/images/v3/system/icon_3.png',
        label: 'דוח שיחות',
        route: 'reports',
        routeName: 'reports'
      },
      {
        icon: require('@/assets/sideNav/icon_tips.svg'),
        label: 'היסטוריית מידע ושימושים',
        route: 'callHistory',
        routeName: 'callHistory'
      },
      {
        icon: require('@/assets/sideNav/icon_upload.svg'),
        label: 'העלאת קבצים',
        route: '/upload/page1',
        routeName: 'upload'
      },
      {
        icon: require('@/assets/sideNav/icon_tfutza.svg'),
        label: 'רשימת תפוצה',
        route: 'subscribesList',
        routeName: 'subscribesList'
      },
      {
        icon: 'https://cpanel.clickcall.co.il/serverscall/admin/assets/images/v3/system/icon_7.png',
        label: 'הגדרות',
        route: '/settings/page1',
        routeName: 'settings'
      },
      {
        icon: require('@/assets/sideNav/icon_help_large.svg'),
        label: 'מידע ועזרה',
        route: 'help',
        routeName: 'help'
      },
      {
        icon: require('@/assets/sideNav/icon_surveys.svg'), 
        label: 'סקרים',
        route: 'surveys',
        routeName: 'surveys'
      },
    ]
  }),
  computed: {
    openMode: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
    ...mapState(['isAdminSwitched', "isAgentSwitched", "role"]), // Get Vuex state
    visibleMenuItems() {
      const items = this.menuItems.filter(item => item.routeName !== 'surveys' || this.surveysAllowed);

      // פאנל הניהול (אדמין או סוכן) - מיד אחרי "שיחות און ליין", כדי שלא יצטרכו לגלול אליו.
      // הלחיצה והסימון כמו קודם: adminRoute/agentRoute, ופעיל בכל דף שהנתיב שלו כולל /admin או /agent
      const panelIcon = require('@/assets/sideNav/icon_users_panel.svg');
      let panel = null;
      if (this.role === 'admin') {
        panel = { icon: panelIcon, label: 'פאנל ניהול כללי', activePath: '/admin', onClick: this.adminRoute };
      } else if (this.role === 'agent') {
        panel = { icon: panelIcon, label: 'פאנל ניהול סוכן', activePath: '/agent', onClick: this.agentRoute };
      }
      if (panel) {
        const at = items.findIndex(item => item.routeName === 'onLineUsers');
        items.splice(at === -1 ? items.length : at + 1, 0, panel);
      }
      return items;
    },
  },
  watch: {
    // התפריט נשאר טעון כשאדמין או סוכן עוברים למערכת אחרת - בודקים מחדש בכל מעבר דף.
    // ההגדרות נשמרות לפי טוקן ב-systemSettings.service, כך שזו קריאה לשרת רק כשהטוקן התחלף
    $route() {
      this.refreshSurveysAllowed();
    },
  },
  mounted() {
    this.refreshSurveysAllowed();
  },
  methods: {
    ...mapMutations(['TOGGLE_ADMIN_SWITCH', 'TOGGLE_AGENT_SWITCH']), // Import mutation

    swichToAdmin() {
      localStorage.setItem("token", localStorage.getItem("tokenAdmin"));
      localStorage.removeItem("tokenAdmin");

      if (localStorage.getItem("tokenAgent")) {
        localStorage.removeItem("tokenAgent");
      }
      this.TOGGLE_ADMIN_SWITCH();
      this.$router.replace({ path: '/admin/page1' })
    },

    swichToAgent() {
      localStorage.setItem("token", localStorage.getItem("tokenAgent"));
      localStorage.removeItem("tokenAgent");
      this.TOGGLE_AGENT_SWITCH();
      this.$router.replace({ path: '/agent/page1' })
    },

    navigate(route) {
      if (route.includes('/')) {
        if (this.$route.path !== route) {
          this.$router.push({ path: route });
        }
      } else {
        if (this.$route.name !== route) {
          this.$router.push({ name: route });
        }
      }
    },

    agentRoute() {
      if (this.$route.name !== 'agent') {
        this.$router.push({ path: '/agent/page1' });
      }
    },

    adminRoute() {
      if (this.$route.name !== 'admin') {
        this.$router.push({ path: '/admin/page1' });
      }
    },

    logOut() {
      localStorage.removeItem("token");
      this.$router.replace({ name: 'login' });
    },

    toggleDrawer() {
      // Add a smooth transition when toggling the drawer
      document.documentElement.style.setProperty('--drawer-transition-duration', '0.4s');
      this.isCollapsed = !this.isCollapsed;

      // Reset the transition duration after the transition completes
      setTimeout(() => {
        document.documentElement.style.setProperty('--drawer-transition-duration', '0.3s');
      }, 400);
    },

    async refreshSurveysAllowed() {
      this.surveysAllowed = await isSurveysAllowed();
    },

    // פריט רגיל מנווט לפי route. פריט עם onClick (פאנל הניהול) מפעיל את הפונקציה שלו
    onItemClick(item) {
      if (item.onClick) return item.onClick();
      this.navigate(item.route);
    },

    isItemActive(item) {
      if (item.activePath) return this.$route.path.includes(item.activePath);
      return this.isActiveRoute(item.route, item.routeName);
    },

    isActiveRoute(route, routeName) {
      if (route.includes('/')) {
        return this.$route.path.includes(route);
      } else {
        return this.$route.name === routeName;
      }
    }
  }
}
</script>

<style scoped>
/* CSS Variables for animations */
:root {
  --drawer-transition-duration: 0.3s;
  --menu-item-transition-duration: 0.25s;
  --hover-transition-duration: 0.2s;
  --active-transition-duration: 0.3s;
  --icon-transition-duration: 0.3s;
}

/* Main container styling */
.side-menu {
  background: linear-gradient(135deg, #0e3280 0%, #0a2357 100%) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.08);
  overflow: hidden;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
  transition: width var(--drawer-transition-duration) cubic-bezier(0.4, 0, 0.2, 1),
    transform var(--drawer-transition-duration) cubic-bezier(0.4, 0, 0.2, 1);
}

/* Header section styling */
.menu-header {
  padding: 0 0;
  transition: padding var(--drawer-transition-duration) ease;
}

.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  transition: all var(--drawer-transition-duration) ease;
}

.action-button {
  background-color: rgba(255, 255, 255, 0.08) !important;
  border-radius: 10px;
  transition: all var(--hover-transition-duration) cubic-bezier(0.4, 0, 0.2, 1) !important;
  margin: 0 4px;
  height: 40px !important;
  width: 40px !important;
  position: relative;
  overflow: hidden;
}

.action-button::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.4s ease, height 0.4s ease;
  z-index: 0;
}

.action-button:hover::before {
  width: 150%;
  height: 150%;
}

.action-button:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.action-button:active {
  transform: translateY(0);
  transition: transform 0.1s ease;
}

.logout-button img {
  width: 24px;
  height: 24px;
  transition: transform var(--icon-transition-duration) ease;
}

.logout-button:hover img {
  transform: scale(1.1);
}

/* Logo section styling */
.logo-section {
  padding: 0 0;
  text-align: center;
  transition: all var(--drawer-transition-duration) ease-in-out;
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.main-logo {
  margin-bottom: 20px;
  transition: all var(--drawer-transition-duration) ease;
}

.main-logo img {
  width: 75%;
  height: auto;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  transition: all var(--drawer-transition-duration) ease;
}

.secondary-logo {
  position: relative;
  width: 100%;
  transition: all var(--drawer-transition-duration) ease;
}

.secondary-logo img {
  width: 100%;
  height: auto;
  transition: all var(--drawer-transition-duration) ease;
}

.logo-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  text-align: center;
  transition: all var(--drawer-transition-duration) ease;
}

.logo-text span {
  display: block;
  font-weight: 500;
  font-size: 17px;
  margin-bottom: 4px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  transition: all var(--drawer-transition-duration) ease;
}

.highlight-text {
  color: #ffb91a;
  font-weight: 700 !important;
  font-size: 19px !important;
  transition: all var(--drawer-transition-duration) ease;
}

.menu-divider {
  height: 1px;
  background: linear-gradient(to right, rgba(46, 74, 117, 0.1), rgba(46, 74, 117, 0.8), rgba(46, 74, 117, 0.1));
  margin: 16px 16px 0;
  transition: all var(--drawer-transition-duration) ease;
}

/* Menu items styling - Expanded view */
.menu-items-container {
  height: calc(100% - 240px);
  overflow-y: auto;
  padding: 0 0;
  transition: all var(--drawer-transition-duration) cubic-bezier(0.4, 0, 0.2, 1);
}

/* Fade-slide transition for menu containers */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

.menu-list {
  padding: 8px 0;
  background-color: transparent;
  transition: padding var(--drawer-transition-duration) ease;
}

.menu-list-item {
  border-radius: 12px;
  margin: 6px 12px;
  transition: all var(--menu-item-transition-duration) cubic-bezier(0.4, 0, 0.2, 1);
  border-bottom: 1px solid rgba(46, 74, 117, 0.3);
  padding: 0 0;
  position: relative;
  overflow: hidden;
}

.menu-list-item::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 3px;
  height: 0;
  background-color: #ffb91a;
  transition: height 0.3s ease;
}

.menu-list-item:hover::before {
  height: 100%;
}

.menu-list-item:last-child {
  border-bottom: none;
}

.menu-list-item:hover {
  background-color: rgba(255, 255, 255, 0.08) !important;
  transform: translateX(-3px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.menu-list-item.active {
  background-color: rgba(255, 185, 26, 0.15) !important;
  border-right: 4px solid #ffb91a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all var(--active-transition-duration) cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-list-item.active::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at right, rgba(255, 185, 26, 0.1), transparent 70%);
  pointer-events: none;
}

.menu-icon {
  margin-left: 18px;
  min-width: 48px;
  display: flex;
  justify-content: center;
  transition: all var(--drawer-transition-duration) ease;
}

.menu-icon-img {
  width: 30px;
  height: 30px;
  object-fit: contain;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
  transition: transform var(--icon-transition-duration) ease, filter var(--icon-transition-duration) ease;
}

.menu-list-item:hover .menu-icon-img {
  transform: scale(1.1);
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3)) brightness(1.1);
}

.menu-list-item.active .menu-icon-img {
  transform: scale(1.1);
  filter: drop-shadow(0 2px 4px rgba(255, 185, 26, 0.4)) brightness(1.2);
}

.menu-item-title {
  color: #fff;
  font-size: 17px;
  font-weight: 500;
  letter-spacing: 0.2px;
  transition: all var(--drawer-transition-duration) ease;
}

/* Menu items styling - Collapsed view */
.collapsed-menu-container {
  padding-top: 20px;
  transition: all var(--drawer-transition-duration) cubic-bezier(0.4, 0, 0.2, 1);
}

.collapsed-menu-list {
  background-color: transparent;
  transition: all var(--drawer-transition-duration) ease;
}

.collapsed-menu-item {
  margin: 12px 0 0 8px;
  display: flex;
  justify-content: center;
  border-radius: 12px;
  transition: all var(--menu-item-transition-duration) cubic-bezier(0.4, 0, 0.2, 1);
  padding: 12px 0;
  position: relative;
  overflow: hidden;
}

.collapsed-menu-item::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 3px;
  height: 0;
  background-color: #ffb91a;
  transition: height 0.3s ease;
}

.collapsed-menu-item:hover::before {
  height: 100%;
}

.collapsed-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.08) !important;
  transform: translateX(-3px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.collapsed-menu-item.active {
  background-color: rgba(255, 185, 26, 0.15) !important;
  border-right: 4px solid #ffb91a;
  transition: all var(--active-transition-duration) cubic-bezier(0.4, 0, 0.2, 1);
}

.collapsed-menu-item.active::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at right, rgba(255, 185, 26, 0.1), transparent 70%);
  pointer-events: none;
}

.collapsed-icon {
  margin: 0;
  min-width: unset;
  display: flex;
  justify-content: center;
  transition: all var(--drawer-transition-duration) ease;
}

.mini-icon {
  width: 25px;
  height: 25px;
  object-fit: contain;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
  transition: transform var(--icon-transition-duration) ease, filter var(--icon-transition-duration) ease;
}

.collapsed-menu-item:hover .mini-icon {
  transform: scale(1.15);
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3)) brightness(1.1);
}

.collapsed-menu-item.active .mini-icon {
  transform: scale(1.15);
  filter: drop-shadow(0 2px 4px rgba(255, 185, 26, 0.4)) brightness(1.2);
}

/* Scrollbar styling */
.menu-items-container::-webkit-scrollbar {
  width: 6px;
  transition: all var(--drawer-transition-duration) ease;
}

.menu-items-container::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  transition: all var(--drawer-transition-duration) ease;
}

.menu-items-container::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 6px;
  transition: all var(--drawer-transition-duration) ease;
}

.menu-items-container::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.35);
}

/* Font styling */
@font-face {
  font-family: 'Heebo';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/heebo/v22/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EiSysd0mm_00.woff2) format('woff2');
  unicode-range: U+0590-05FF, U+200C-2010, U+20AA, U+25CC, U+FB1D-FB4F;
}

@font-face {
  font-family: 'Heebo';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/heebo/v22/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EiSysdUmm.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

/* Animation for active menu item */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 185, 26, 0.4);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(255, 185, 26, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(255, 185, 26, 0);
  }
}

.menu-list-item.active,
.collapsed-menu-item.active {
  animation: pulse 2s infinite;
}
</style>